import { GQLEngraving, GQLEngravingType } from '@jewelutions/core-crm-server-api-client-domain';

export class GQLEngravingHelper {
  static getEngravingAssets(engravings: GQLEngraving[]): { fontIds: string[]; symbolIds: string[] } {
    const fontIds: string[] = [];
    const symbolIds: string[] = [];

    engravings.forEach(engraving => {
      switch (engraving.type) {
        case GQLEngravingType.SingleLetter:
          fontIds.push(engraving.text!.fontId!);
          break;
        case GQLEngravingType.Text:
          fontIds.push(engraving.text!.fontId!);
          break;
        case GQLEngravingType.Symbol:
          symbolIds.push(engraving.symbol!.symbolId!);
          break;
      }
    });

    return { fontIds: fontIds, symbolIds: symbolIds };
  }
}
